var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventCal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enterprise",
    transform: "translate(-1294.000000, -11605.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(1294.000000, 11605.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-43-Copy-6",
    fill: "#F3F3F3",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "reshot-icon-calendar-T42UZFVNBG",
    transform: "translate(21.000000, 23.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.875,3.399694 L28.1875,3.399694 L28.1875,0 L24.7706625,0 L24.7706625,3.399694 L21.3543375,3.399694 L21.3543375,0 L17.9375,0 L17.9375,3.399694 L14.5206625,3.399694 L14.5206625,0 L11.103825,0 L11.103825,3.399694 L5.125,3.399694 L0,34 L41,34 L35.875,3.399694 Z M4.033375,30.600306 L8.0196,6.799898 L11.1043375,6.799898 L11.1043375,10.200102 L14.521175,10.200102 L14.521175,6.799898 L17.9375,6.799898 L17.9375,10.200102 L21.3543375,10.200102 L21.3543375,6.799898 L24.7706625,6.799898 L24.7706625,10.200102 L28.1875,10.200102 L28.1875,6.799898 L31.8411125,6.799898 L27.8559125,30.600306 L4.033375,30.600306 Z M34.1432625,13.7410674 L36.9661125,30.600306 L31.3204125,30.600306 L34.1432625,13.7410674 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "24.3998338 17.2501219 25 14 14.4012051 14 13.8010389 17.2501219 19.9318097 17.2501219 12 27 16.4685643 27"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCal);
export default __webpack_public_path__ + "static/media/event-cal.09b1ff643d4d2a8fbef773763e313017.svg";
export { ForwardRef as ReactComponent };